import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {applyPolyfills, defineCustomElements as defineSelectComponent} from 'bth-components/loader';
import {defineCustomElements} from '@betha-plataforma/estrutura-componentes/loader';

if (environment.production) {
    enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
});

applyPolyfills()
    .then(() => {
        defineSelectComponent(window);
        defineCustomElements(window);
    });
